import { JsonObject, JsonProperty } from "json2typescript";
import { DateConverter } from "domain/entities/decorators/DateConverter";

@JsonObject("TypeInteractionResult")
export class TypeInteractionResult {
    @JsonProperty("dti_id", Number)
    id: number = 0;
    @JsonProperty("dti_name", String)
    name: string = "";
    @JsonProperty("dti_description", String)
    description: string = "";
    @JsonProperty("dti_created_at", DateConverter)
    createdAt: Date = new Date();
    @JsonProperty("dti_updated_at", DateConverter)
    updatedAt: Date = new Date();
}